// Public URL of the standalone organizer portal. Mobile users tap "Manage" on
// an event card (or "Organizer" in Profile) to jump here. The URL is provided
// via env var so the same code works across preview and production.
export const ORGANIZER_URL = process.env.REACT_APP_ORGANIZER_URL;

export function organizerEventUrl(eventId) {
  const base = ORGANIZER_URL || '';
  if (!eventId) return base;
  return `${base}/?event=${encodeURIComponent(eventId)}`;
}
